import { Controller } from '@hotwired/stimulus'

export default class DobController extends Controller {
  static targets = ['day', 'month', 'year', 'agePolicy', 'underThirteenPolicy', 'agePolicyCheckbox', 'underThirteenPolicyCheckbox']

  connect() {
    this.updateDays()
    this.updateAgePolicies()
  }

  updateDays() {
    const year = parseInt(this.yearTarget.value, 10)
    const month = parseInt(this.monthTarget.value, 10)

    const today = new Date()
    const currentYear = today.getFullYear()
    const currentMonth = today.getMonth() + 1
    const currentDay = today.getDate()

    // Enable all month options
    Array.from(this.monthTarget.options).forEach((option) => {
      option.disabled = false
    })

    // Disable future months for current year
    if (year === currentYear) {
      Array.from(this.monthTarget.options).forEach((option) => {
        const value = parseInt(option.value, 10)
        if (!isNaN(value) && value > currentMonth) {
          option.disabled = true
        }
      })

      if (month > currentMonth) {
        this.monthTarget.value = ""
        this.dayTarget.value = ""
        return
      }
    }

    if (!year || !month) {
      this.dayTarget.value = ""
      return
    }

    const maxDays = new Date(year, month, 0).getDate()

    // Enable/disable day options
    Array.from(this.dayTarget.options).forEach((option) => {
      const value = parseInt(option.value, 10)
      if (isNaN(value)) return // Skip prompt option if present

      option.disabled = false
      if (value > maxDays) {
        option.disabled = true
      }

      if (
        year === currentYear &&
        month === currentMonth &&
        value > currentDay
      ) {
        option.disabled = true
      }
    })

    const selectedDay = parseInt(this.dayTarget.value, 10)
    if (
      selectedDay > maxDays ||
      (year === currentYear &&
        month === currentMonth &&
        selectedDay > currentDay)
    ) {
      this.dayTarget.value = ""
      $(this.dayTarget).trigger("change")
    }

    this.updateAgePolicies()
  }

  updateAgePolicies() {
    if (!this.hasAgePolicyTarget || !this.hasUnderThirteenPolicyTarget) {
      return
    }

    const year = parseInt(this.yearTarget.value, 10)
    const month = parseInt(this.monthTarget.value, 10)
    const day = parseInt(this.dayTarget.value, 10)

    // Hide both until a complete DOB is selected
    if (!year || !month || !day) {
      this.hidePolicies()
      return
    }

    const today = new Date()
    let age = today.getFullYear() - year

    if (
      today.getMonth() + 1 < month ||
      (today.getMonth() + 1 === month && today.getDate() < day)
    ) {
      age--
    }

    if (age < 13) {
      // Show under-13 policy
      this.underThirteenPolicyTarget.classList.remove("d-none")
      this.agePolicyTarget.classList.add("d-none")

      this.underThirteenPolicyCheckboxTarget.required = true
      this.agePolicyCheckboxTarget.required = false
      this.agePolicyCheckboxTarget.checked = false
    } else if (age <= 17) {
      // Show 13-17 policy
      this.agePolicyTarget.classList.remove("d-none")
      this.underThirteenPolicyTarget.classList.add("d-none")

      this.agePolicyCheckboxTarget.required = true
      this.underThirteenPolicyCheckboxTarget.required = false
      this.underThirteenPolicyCheckboxTarget.checked = false
    } else {
      // 18+
      this.hidePolicies()
    }
  }

  hidePolicies() {
    this.agePolicyTarget.classList.add("d-none")
    this.underThirteenPolicyTarget.classList.add("d-none")

    this.agePolicyCheckboxTarget.required = false
    this.underThirteenPolicyCheckboxTarget.required = false

    this.agePolicyCheckboxTarget.checked = false
    this.underThirteenPolicyCheckboxTarget.checked = false
  }
}
